<div class="form-field">
  <label>
    {{ item.translation_key_label || item.label || 'select_datax_role' | translation | translationFromString | transformText : item?.text_transform_label }}
    <span *ngIf="item.required">*</span>
  </label>

  <p-select
    [options]="roleOptions"
    [(ngModel)]="selectedRole"
    (onChange)="onRoleChange($event.value)"
    [loading]="loading"
    [required]="item.required"
    [disabled]="checkDisable()"
    [placeholder]="item.translation_key_label || item.label || 'select_datax_role' | translation | translationFromString | transformText : item?.text_transform_label"
    optionLabel="label"
    optionValue="value"
    [showClear]="true"
    fluid
    appendTo="body"
  >
  </p-select>
</div>